import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Brain } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-cream-50" data-id="element-44">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-45">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-sage-100/50 blur-3xl" data-id="element-46" />
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-amber-50/50 blur-3xl" data-id="element-47" />
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex justify-center items-center gap-4 mb-8 text-sage-600" data-id="element-49">
          <Brain className="w-8 h-8" data-id="element-50" />
          <span className="w-1.5 h-1.5 rounded-full bg-sage-300" data-id="element-51" />
          <Heart className="w-8 h-8" data-id="element-52" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-serif text-5xl md:text-6xl lg:text-7xl leading-tight mb-6 text-navy" data-id="element-53">
          Obediencia Sin Gritos: <br className="hidden md:block" data-id="element-54" />
          <span className="text-navy" data-id="element-55">El Método de los Neuro-Comandos</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-stone-600 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-56">
          Logra que tus hijos te escuchen a la primera sin tener que repetir las
          cosas 10 veces ni terminar explotando.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        type: 'spring',
        bounce: 0.4
      }} className="relative max-w-md mx-auto mb-12 z-10" data-id="element-57">
          <div className="absolute inset-0 bg-skyblue/60 blur-3xl rounded-full transform scale-105 -z-10" data-id="element-58" />
          <motion.img animate={{
          y: [-5, 5, -5]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} src="https://cdn.magicpatterns.com/uploads/nGK4L7DYp6Qv14tTVzYzFf/heylloyd-image-1776722968307.png" alt="El Desafío de las Rabietas - Antes del Método de los Neuro-Comandos" className="w-full h-auto rounded-3xl shadow-2xl border-4 border-white/80 object-cover" data-id="element-59" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-60">
          <CTAButton data-id="element-61" />
          <p className="mt-4 text-sm text-stone-500 font-medium" data-id="element-62">
            Compra segura • Entrega digital inmediata
          </p>
        </motion.div>
      </div>
    </section>;
}